const plutoQuiz = [ 
    {
    question: "Pluto diklasifikasikan sebagai apa?",
    options: [
      "Planet utama",
      "Planet raksasa gas",
      "Planet kerdil",
      "Asteroid",
    ],
    answer: 2,
  },
  {
    question: "Pluto berada di wilayah mana dalam tata surya?",
    options: [
      "Sabuk Asteroid",
      "Awan Oort",
      "Sabuk Kuiper",
      "Dekat Matahari",
    ],
    answer: 2,
  },
  {
    question: "Kapan Pluto diklasifikasikan sebagai planet kerdil?",
    options: ["1996", "2000", "2006", "2012"],
    answer: 2,
  },
  {
    question: "Mengapa Pluto tidak lagi disebut planet utama?",
    options: [
      "Karena terlalu kecil",
      "Karena orbitnya tidak membersihkan lintasannya",
      "Karena terlalu jauh",
      "Karena tidak memiliki atmosfer",
    ],
    answer: 1,
  },
  {
    question: "Suhu permukaan Pluto umumnya?",
    options: [
      "Sangat panas",
      "Sedang",
      "Sangat dingin",
      "Sama seperti Neptunus",
    ],
    answer: 2,
  },
  {
    question: "Pluto ditemukan oleh siapa?",
    options: [
      "Galileo Galilei",
      "Edwin Hubble",
      "Clyde Tombaugh",
      "Isaac Newton",
    ],
    answer: 2,
  },
  {
    question: "Apakah Pluto memiliki bulan?",
    options: [
      "Tidak",
      "Ya, satu",
      "Ya, lima",
      "Ya, lebih dari sepuluh",
    ],
    answer: 2,
  },
  {
    question: "Bulan terbesar Pluto bernama?",
    options: [
      "Charon",
      "Triton",
      "Europa",
      "Phobos",
    ],
    answer: 0,
  },
  {
    question: "Pluto membutuhkan waktu berapa lama untuk mengelilingi Matahari?",
    options: [
      "88 tahun",
      "165 tahun",
      "248 tahun",
      "365 tahun",
    ],
    answer: 2,
  },
  {
    question: "Misi wahana antariksa yang pernah mengunjungi Pluto adalah?",
    options: [
      "Voyager 2",
      "New Horizons",
      "Apollo 11",
      "Cassini",
    ],
    answer: 1,
  },
]

export default plutoQuiz;